import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=29e57b50"
import script from "./UserRoles.vue?vue&type=script&lang=js"
export * from "./UserRoles.vue?vue&type=script&lang=js"
import style0 from "./UserRoles.vue?vue&type=style&index=0&id=29e57b50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports